$(window).on('load', function () {

  if ($('.c-section-title').length) {
    var target = $(".c-section-title").length;
    for (let i = 0; i < target; i++) {
      $(".c-section-title").eq(i).addClass('is-section-' + (i + 1));

      let sub_left = $(".c-section-title").eq(i).children('.-sub').width();
      $(".c-section-title").eq(i).children('.-border').css('left', sub_left + 'px');

      let leng = $(window).width() - (($(window).width() - 960) / 2) - sub_left;
      $(".c-section-title").eq(i).children('.-border').css('width', leng + 'px');
    }

    $(window).resize(function () {
      for (let i = 0; i < target; i++) {
        $(".c-section-title").eq(i).addClass('is-section-' + (i + 1));

        let sub_left = $(".c-section-title").eq(i).children('.-sub').width();
        $(".c-section-title").eq(i).children('.-border').css('left', sub_left + 'px');

        let leng = $(window).width() - (($(window).width() - 960) / 2) - sub_left;
        $(".c-section-title").eq(i).children('.-border').css('width', leng + 'px');
      }
    });
  }
});
